export const stripeClient = () => {
  return Stripe(envVariables["stripe_pk"], { locale: "fr" });
};
